var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MessageContainer',{attrs:{"level":_vm.level}},[_c('strong',[_vm._v(" "+_vm._s(_vm.messageHeader)+" ")]),_vm._v(_vm._s(_vm.message)+" "),(_vm.href)?_c('ExternalLink',{attrs:{"href":_vm.href,"showExternalLinkIcon":false,"text":_vm.linkText}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }